import { Box, Typography } from "@mui/material";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";

import { IDataTh, ThCoreIndex } from "src/Pages/components";

const HeaderItem = ({
  label,
  icon,
}: {
  label: string;
  icon: React.ReactNode;
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        color: "text.secondary",
      }}
    >
      {icon}
    </Box>

    <Typography
      sx={{
        fontSize: 12,
        fontWeight: 800,
        color: "text.secondary",
        textTransform: "uppercase",
        letterSpacing: 0.6,
      }}
    >
      {label}
    </Typography>
  </Box>
);

export const THeadLogs = () => {
  const dataTh: IDataTh[] = [
    {
      title: (
        <HeaderItem
          label="Usuário"
          icon={<PersonOutlineRoundedIcon fontSize="small" />}
        />
      ),
      align: "left",
      width: "160px",
      minWidth: "130px",
    },
    {
      title: (
        <HeaderItem label="Ação" icon={<BoltRoundedIcon fontSize="small" />} />
      ),
      width: "140px",
      minWidth: "120px",
      align: "left",
    },
    {
      title: (
        <HeaderItem
          label="Entidade"
          icon={<BusinessRoundedIcon fontSize="small" />}
        />
      ),
      width: "200px",
      minWidth: "160px",
      align: "left",
    },
    {
      title: "Data",
      width: "180px",
      minWidth: "160px",
      align: "center",
    },
    {
      title: (
        <HeaderItem
          label="Detalhes"
          icon={<VisibilityRoundedIcon fontSize="small" />}
        />
      ),
      width: "180px",
      minWidth: "160px",
      align: "left",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
